export const convertPeriod = (tenors) => {
    let convertedTenors = [];

    if (tenors.length !== 0) {
        tenors.forEach((tenor, index) => {
            convertedTenors.push({
                value: tenor.period,
                label: `${tenor.period} Periode`,
                days: [tenor.days]
            });
        });
    }

    const arrayHashmap = convertedTenors.reduce((obj, item) => {
        obj[item.value] ? obj[item.value].days.push(...item.days) : (obj[item.value] = { ...item });
        return obj;
    }, {});

    const mergedArray = Object.values(arrayHashmap);

    const unique = [...new Map(mergedArray.map((m) => [m.value, m])).values()]; //get uniq value
    return unique;
};